exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.return[data-v-85603366]{\n    text-decoration: underline;\n    font-size: 1.2rem;\n    margin-right: 5%;\n    cursor: pointer;\n    color: #207474;\n}\n.return[data-v-85603366]:hover{\n    color: blue;\n}\n.btnWrap[data-v-85603366] {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n", ""]);

// exports
